import React, {useState, useEffect} from 'react';
import ReactDom from 'react-dom';
import {useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import * as ProfileStyle from '../../ProfileInfo/ProfileInfo.styles';
import * as S from './ManageGstResp.styles';
import {updateGstFormRow} from '@ibibo/myaccount-reducer';
import {logOmniClick} from '@ibibo/analytics';
import {useModal} from '../../../../../../../../hotels-dweb/src/shared/components/Modal';
import DeleteGstMob from '../DeleteGstMob/DeleteGstMob';
import {convertGstDataMobile} from '../../../../../../utils/formatJson';

const ManageGstResp = ({userData}) => {
  const {isModalOpen, openModal, closeModal} = useModal();
  const [isDeleteModal, setDeleteModal] = useState(false);
  const [modalData, setModalData] = useState({});
  const history = useHistory();
  const dispatch = useDispatch();

  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    setTableData(convertGstDataMobile(userData?.traveller_gst_info?.gstDetails || []));
  }, [userData]);

  const handleDeleteModal = () => {
    setDeleteModal(false);
  };

  const handleDeleteModalClick = gstData => {
    setDeleteModal(true);
    setModalData(gstData?.rowDeleteData || {});
  };

  const redirectToAddGstList = raspGstCard => {
    dispatch(updateGstFormRow(raspGstCard?.rowEditData || {}));
    history.push('/myAddGstList');
  };

  return (
    <ProfileStyle.ProfileMainWrap>
      <ProfileStyle.ProfileInnerWrap>
        <ProfileStyle.ProfileHeadOuterWrap>
          <ProfileStyle.ProfileHeadInnerWrap>
            <ProfileStyle.HeadMainText>Manage GST </ProfileStyle.HeadMainText>
            <ProfileStyle.HeadSubText>
              Add details of your travel agency's or client’s GST to save them for reuse
            </ProfileStyle.HeadSubText>
          </ProfileStyle.ProfileHeadInnerWrap>
          <ProfileStyle.AddLink
            onClick={() => {
              logOmniClick('mysettings:gst', {
                prop54: `CTA –Add_GST_Clicked `,
              }),
                redirectToAddGstList({});
            }}
          >
            +ADD
          </ProfileStyle.AddLink>
        </ProfileStyle.ProfileHeadOuterWrap>
        <S.manageGstRespWrap>
          {tableData?.length
            ? tableData.map(raspGstCard => (
                <S.gstDetailCard key={raspGstCard?.id} background={raspGstCard?.gstDtlCardBg}>
                  <div className="makeFlex spaceBetween">
                    <div className="maxWidth">
                      <div className="makeFlex hrtlCenter">
                        <p className="gstCardHeading">{raspGstCard?.gstDtlHeading}</p>
                        <S.gstDtlStatusTag
                          background={raspGstCard?.gstDtlCardTag?.cardTagBgColor}
                          color={raspGstCard?.gstDtlCardTag?.cardTagColor}
                          margin="0px 0px 0px 8px"
                          border={raspGstCard?.gstDtlCardTag?.cardTagBorderColor}
                        >
                          {raspGstCard?.gstOwner}
                        </S.gstDtlStatusTag>
                      </div>
                      <p className="gstCardSubHeading">{raspGstCard?.gstDtlSubHeading}</p>
                      <p className="gstCardSubHeading">
                        {raspGstCard?.gstState + ',' + raspGstCard?.gstPinCode}
                      </p>
                      <p className="gstCardSubHeadingTwo">{raspGstCard?.gstDtlSubHeadingTwo}</p>
                    </div>
                    <div className="makeFlex hrtlCenter appendLeft16">
                      <span
                        className={`${raspGstCard?.gstDtlCardIcOne}`}
                        onClick={() => {
                          logOmniClick('mysettings:gst', {
                            prop54: `CTA –Edit_GST_Clicked `,
                          }),
                            redirectToAddGstList(raspGstCard);
                        }}
                      ></span>
                      <span
                        className={`marginLeft16 ${raspGstCard?.gstDtlCardIcTwo}`}
                        onClick={() => handleDeleteModalClick(raspGstCard)}
                      ></span>
                    </div>
                  </div>
                  {/* <S.ProfileRowPersuasion
              background="linear-gradient(90.13deg, #C1F1DD 0.02%, rgba(193, 241, 221, 0) 112.91%)"
              color="#1a7971"
              margin="8px 0px 0px 0px"
            >
              <span className="sprite icGreenBgTick"></span>
              <span className="marginLeft8">GST details were saved successfully</span>
            </S.ProfileRowPersuasion> */}
                </S.gstDetailCard>
              ))
            : null}
          {/* <S.manageGstCTA
            border="1px solid #008cff"
            background="#FFF"
            color="#008cff"
            onClick={redirectToSavedGstList}
          >
            View All Saved Gst
          </S.manageGstCTA> */}
        </S.manageGstRespWrap>
      </ProfileStyle.ProfileInnerWrap>
      {isDeleteModal &&
        ReactDom.createPortal(
          <DeleteGstMob modalData={modalData} onClose={handleDeleteModal} />,
          document.getElementById('modal-root'),
        )}
    </ProfileStyle.ProfileMainWrap>
  );
};

export default ManageGstResp;
